import React from "react";
import { useDispatch, useSelector } from "react-redux";
import withStyles from "@material-ui/styles/withStyles";
import { Button } from "@material-ui/core";

import { styles } from "./ParkOffButton.styles";
import { reservationNewReservationParkoffBo, selectActionIsLoading } from "../../../reservationsSlice";

function ParkOffButton({ classes, reservation, actions }) {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectActionIsLoading);

  const { code, carToken } = reservation;

  const onParkOffHandler = () => {
    dispatch(reservationNewReservationParkoffBo({ reservationCode: code, carToken }, actions));
  };

  return (
    <div className={classes.root}>
      <Button variant="outlined" color="primary" onClick={onParkOffHandler} disabled={isLoading}>
        ParkOff
      </Button>
    </div>
  );
}

export default withStyles(styles)(ParkOffButton);
